import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import PdfViewer from "../../components/controls/pdfviewer";
import ViewCaseInfo from "../../components/core/case_views/caseinfo";
import ViewComments from "../../components/core/case_views/comments";
import ViewDocuments from "../../components/core/case_views/documents";
import ViewMotions from "../../components/core/case_views/motions";
import ViewClaims from "../../components/core/case_views/claims";
import JisPrompt from "../../components/jisprompt";

function Mediation() {
  const navigate = useNavigate();
  const { caseid } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);

  const [settleStatus, setSettleStatus] = useState("");
  const [preInfo, setPreInfo] = useState(null);
  const [caseData, setCaseData] = useState(null);
  const [tab, setTab] = useState("summary");
  const [summaryType, setSummaryType] = useState("text");
  const [attendee, setAttendee] = useState(new Set());
  const [attendeeItem, setAttendeeItem] = useState({});
  const [comment, setComment] = useState("");
  const [isPrompt, setIsPrompt] = useState(false);
  const [promptTitle, setPromptTitle] = useState("");
  const [promptMessage, setPromptMessage] = useState("");
  const [summary, setSummary] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [sFile, setSFile] = useState(null);
  const [previewPath, setPreviewPath] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [adjournDate, setAdjournDate] = useState(null);
  const [adjournTime, setAdjournTime] = useState(null);

  const onLoad = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCaseData(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    onLoadpreinfo(caseid);
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLoadpreinfo = async (caseid) => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-pre-session/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setPreInfo(data.pre);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onCheck = (v, type) => {
    const id = `${type}-${v.id}`;
    var _att = new Set(attendee);
    var _items = { ...attendeeItem };
    if (_att.has(id)) {
      _att.delete(id);
      delete _items[id];
    } else {
      _att.add(id);
      _items[id] = {
        adrMediatorId: 0,
        attendeeId: v.id,
        AttendeeType: type,
        MediationId: 0,
        attendeeName: `${v.firstName} ${v.lastName ?? ""}`,
      };
    }

    setAttendee(new Set(_att));
    setAttendeeItem(_items);
  };

  const onCancelPrompt = () => {
    setIsPrompt(false);
  };

  const onSave = async (e) => {
    e.preventDefault();
    if (summaryType == "file" && sFile == null) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Mediation Meeting",
        subtitle: `Please upload the summary document`,
      });
      return;
    }

    if (settleStatus == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Mediation Meeting",
        subtitle: `Please specify the settle status, is it settled or not settled`,
      });
      return;
    }

    if (Object.keys(attendeeItem).length === 0) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Mediation Attendee",
        subtitle: `Please select the parties in attendance`,
      });
      return;
    }

    // Set prompt title/message depending on settleStatus, then show prompt
    if (settleStatus === "not settled") {
      setPromptTitle("No settlement reached");
      setPromptMessage(
        "The mediation has concluded, and no settlement was reached. Click Yes to continue with next step or No to cancel."
      );
      setIsPrompt(true);
      return;
    }

    if (settleStatus === "settled") {
      setPromptTitle("Mediation Settled");
      setPromptMessage(
        "The parties have reached a settlement. Click Yes to continue or No to cancel."
      );
      setIsPrompt(true);
      return;
    }

    // fallback for adjourn or others
    setPromptTitle("Adjournment");
    setPromptMessage(
      "Are you sure you want to adjourn this case? Click Yes to confirm the adjournment or No to cancel"
    );
    setIsPrompt(true);
  };

  const onFinal = async () => {
    // Called when user clicks Yes on the prompt
    const isSettled =
      settleStatus == "adjourn"
        ? null
        : settleStatus == "settled"
        ? true
        : false;

    setLoading(true);
    var mediation = {
      mediationAttendees: Object.values(attendeeItem),
      caseId: preInfo.caseId,
      mediatorId: 0,
      partiesSettled: isSettled,
      summaryType,
      summary,
      comment,
      adjournDate,
      adjournTime,
    };

    if (summaryType == "file") {
      mediation = {
        ...mediation,
        summaryDoc: sFile.base64,
        filename: sFile.filename,
      };
    }

    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/save-mediation/${preInfo.id}`,
        {
          method: "POST",
          body: JSON.stringify(mediation),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        // close prompt
        setIsPrompt(false);

        // show different alert messages depending on settleStatus
        if (settleStatus === "settled") {
          setAlert({
            open: true,
            title: "Mediation Result",
            subtitle: "The mediation ended successfully with a settlement",
          });
        } else if (settleStatus === "not settled") {
          setAlert({
            open: true,
            title: "Mediation Result",
            subtitle: "No settlement reached",
          });
        } else {
          // adjourn
          setAlert({
            open: true,
            title: "Case Acceptance",
            subtitle: "Case Adjourned successfully",
          });
        }

        // redirect after success
        navigate("/adr-manager-cases/mediator");
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
    }
  };

  const onUploadFiles2 = async (caseid) => {
    const uploadurl = `${Constants.apiUrl}/filing/upload-adr-manager-document/${caseid}`;
    var upline = {
      id: 0,
      uplineType: "attest",
      base64: sFile.base64,
      base64Ext: sFile.base64Ext,
      templateId: 0,
      templatetitle: "",
      filename: sFile.filename,
      docuploadid: 0,
    };

    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(upline),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          setAlert({
            open: true,
            title: "Case Report",
            subtitle: " Case report submited successfully",
          });
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const handleUploadChange = async (e) => {
    const files = e.target.files;
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);
    var path = URL.createObjectURL(files[0]);
    var fname = Constants.ReduceFilename(files[0]?.name);

    var a = {
      path,
      base64: b64.split(",")[1],
      filename: fname,
      base64Ext: b64.split(",")[0],
    };

    setSFile(a);
    console.log(a);
  };

  const onPreview = (obj) => {
    setIsPreview(true);
    setPreviewPath(obj.path);
  };

  return (
    <div>
      Mediation
      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            code="summary"
            isActive={tab == "summary"}
            title="Mediation Summary"
            isRoleBased={false}
            onClick={() => setTab("summary")}
          />
          <JisTabButton
            code="caseinfo"
            isActive={tab == "caseinfo"}
            title="Case Details"
            isRoleBased={false}
            onClick={() => setTab("caseinfo")}
          />
          <JisTabButton
            code="caseclaims"
            isActive={tab == "caseclaims"}
            title="Claims"
            isRoleBased={false}
            onClick={() => setTab("caseclaims")}
          />
          <JisTabButton
            code="casecomments"
            isActive={tab == "casecomments"}
            title="Comments"
            isRoleBased={false}
            onClick={() => setTab("casecomments")}
          />
          <JisTabButton
            code="casedocuments"
            isActive={tab == "casedocuments"}
            title="Documents"
            isRoleBased={false}
            onClick={() => setTab("casedocuments")}
          />
          {caseData?.motions.length > 0 && (
            <JisTabButton
              code="motions"
              isActive={tab == "motions"}
              title="Motions"
              isRoleBased={false}
              onClick={() => setTab("motions")}
            />
          )}
        </div>

        {tab == "summary" && (
          <div className="tab_view">
            <div style={{ display: "flex" }}>
              <form style={{ flex: 1, padding: 8 }} onSubmit={onSave}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    {preInfo?.appearStatusSelected != "Physical" && (
                      <JisButton variant="outline" type="button">
                        <a href={preInfo?.virtualUrlSelected} target="_blank">
                          Join Virtual
                        </a>{" "}
                      </JisButton>
                    )}
                  </div>
                </div>

                <div style={{ display: "flex", width: "50%" }}>
                  <div
                    style={{ flex: 1, textAlign: "center" }}
                    className={`selected ${
                      summaryType == "text" ? "active" : ""
                    } `}
                    onClick={() => setSummaryType("text")}
                  >
                    Summary in Text
                  </div>
                  <div
                    style={{ flex: 1, textAlign: "center" }}
                    className={`selected ${
                      summaryType == "file" ? "active" : ""
                    } `}
                    onClick={() => setSummaryType("file")}
                  >
                    Upload Summary
                  </div>
                </div>
                <hr />
                <div>Meeting Summary</div>

                {summaryType == "text" && (
                  <div>
                    <textarea
                      style={{ width: "100%", height: 350, padding: 8 }}
                      placeholder="Mediation Summary"
                      required={true}
                      value={summary}
                      onChange={(e) => setSummary(e.target.value)}
                    ></textarea>
                  </div>
                )}

                {summaryType == "file" && (
                  <div style={{ margin: 16 }}>
                    <div className="btn-upload">
                      <input
                        type="file"
                        accept="application/pdf"
                        id={`file-upload-${0}`}
                        onChange={(e) => handleUploadChange(e)}
                      />
                      <label
                        htmlFor={`file-upload-${0}`}
                        title={sFile?.filename}
                      >
                        {sFile?.path == null
                          ? "Choose File"
                          : Constants.ReduceString(sFile?.filename, 30)}
                      </label>
                      {sFile?.path != null && (
                        <JisButton onClick={() => onPreview(sFile)}>
                          Preview
                        </JisButton>
                      )}
                    </div>
                  </div>
                )}

                <div style={{ display: "flex" }}>
                  <div
                    style={{ flex: 1, textAlign: "center" }}
                    className={`selected ${
                      settleStatus == "settled" ? "active" : ""
                    } `}
                    onClick={() => setSettleStatus("settled")}
                  >
                    Parties Settled
                  </div>
                  <div
                    style={{ flex: 1, textAlign: "center" }}
                    className={`selected ${
                      settleStatus == "not settled" ? "active" : ""
                    } `}
                    onClick={() => setSettleStatus("not settled")}
                  >
                    Parties Not Settled
                  </div>
                  <div
                    style={{ flex: 1, textAlign: "center" }}
                    className={`selected ${
                      settleStatus == "adjourn" ? "active" : ""
                    } `}
                    onClick={() => setSettleStatus("adjourn")}
                  >
                    Adjourn Mediation
                  </div>
                </div>

                {settleStatus == "adjourn" && (
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label> Adjourn Date</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="date" />
                        <input
                          placeholder="Pre Adjourn Date"
                          value={adjournDate}
                          onChange={(e) => setAdjournDate(e.target.value)}
                          required={true}
                          type="date"
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label> Adjourn Time</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="time" />
                        <input
                          placeholder="Pre Adjourn Time"
                          value={adjournTime}
                          onChange={(e) => setAdjournTime(e.target.value)}
                          required={true}
                          type="time"
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="input-group">
                  <label>
                    {" "}
                    Comment<span className="required">*</span>{" "}
                  </label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="group" />
                    <textarea
                      placeholder="comment"
                      required={true}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <JisButton type="submit">Save Mediation</JisButton>
                </div>
              </form>

              <div style={{ width: "30%", padding: 8 }}>
                <div></div>
                <div>Parties In Attendance</div>
                <div>
                  {caseData?.parties?.map((opt) => (
                    <React.Fragment key={`p-${opt.id}`}>
                      <div
                        style={{ textAlign: "center" }}
                        className={`selected ${
                          attendee.has(`p-${opt.id}`) ? "active" : ""
                        } `}
                        onClick={() => onCheck(opt, "p")}
                      >
                        {opt.firstName} {opt.lastName ?? ""} - {opt.title}{" "}
                        {attendee.has(`p-${opt.id}`) && (
                          <DynamicIcon iname="check_circle" />
                        )}{" "}
                      </div>
                      <p style={{ fontSize: 12, textAlign: "center" }}>
                        Phone: {opt.primaryContactNumber} | Email:{" "}
                        {opt.primaryEmail}{" "}
                      </p>
                    </React.Fragment>
                  ))}
                  {caseData?.legalcounsels?.map((opt) => (
                    <React.Fragment key={`l-${opt.id}`}>
                      <div
                        style={{ textAlign: "center" }}
                        className={`selected ${
                          attendee.has(`l-${opt.id}`) ? "active" : ""
                        } `}
                        onClick={() => onCheck(opt, "l")}
                      >
                        {opt.firstName} {opt.lastName ?? ""} - Legal Counsel{" "}
                        {attendee.has(`l-${opt.id}`) && (
                          <DynamicIcon iname="check_circle" />
                        )}
                      </div>
                      <p style={{ fontSize: 12, textAlign: "center" }}>
                        Phone: {opt.primaryContactNumber} | Email:{" "}
                        {opt.primaryEmail}{" "}
                      </p>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {tab == "caseinfo" && caseData != null && (
          <div className="tab_view">
            <ViewCaseInfo
              caseId={caseid}
              caseinfo={{
                ...caseData.caseinfo,
                claims: caseData.claims,
                fiats: caseData.fiats,
                causes: caseData.causes,
                parties: caseData.parties,
                assigneduser: caseData.assigneduser,
                deputysheriff: caseData.deputysheriff,
                legalcounsels: caseData.legalcounsels,
                presessions: caseData.presessions,
                mediations: caseData.mediations,
              }}
              isAction={false}
            />
          </div>
        )}

        {tab == "caseclaims" && caseData != null && (
          <div className="tab_view">
            <ViewClaims
              caseId={caseid}
              claims={caseData.claims}
              isAction={false}
            />
          </div>
        )}

        {tab == "casecomments" && caseData != null && (
          <div className="tab_view">
            <ViewComments
              caseId={caseid}
              comments={caseData.comments}
              isAction={false}
            />
          </div>
        )}

        {tab == "casedocuments" && caseData != null && (
          <div className="tab_view">
            <ViewDocuments
              caseId={caseid}
              documents={caseData.documents}
              isAction={false}
            />
          </div>
        )}

        {tab == "motions" && caseData != null && (
          <div className="tab_view">
            <ViewMotions
              caseId={caseid}
              motions={caseData.motions}
              isAction={false}
            />
          </div>
        )}
      </div>
      <BackLoader open={loading} />
      <JisPrompt
        open={isPrompt}
        title={promptTitle}
        onOk={onFinal}
        onCancel={onCancelPrompt}
      >
        <p>{promptMessage}</p>
      </JisPrompt>
      {isPreview && (
        <JisDialogForm
          title="Preview"
          onClose={() => setIsPreview(false)}
          minWidth="70%"
        >
          <div style={{ height: 500 }}>
            <PdfViewer pdfUrl={previewPath} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default Mediation;
